
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-demo-class-video",
      function () {
        return require("private-next-pages/tnpsc-demo-class-video/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-demo-class-video"])
      });
    }
  